import { EntityChange, EntityChangeKind } from './layerTypes'

/**
 * Whether the canvas has no node for this change's entity. Changes are named
 * from the newer version, so which kind is missing depends on the side shown.
 */
export function isAbsentFromCanvas(
  kind: EntityChangeKind,
  isViewingNewer: boolean
): boolean {
  return isViewingNewer ? kind === 'removed' : kind === 'added'
}

/**
 * Whether a changed entity can be shown split: both versions have it, and at
 * the same size, so one line across it means the same thing on either side.
 *
 * A resized entity gets the swap instead - there is no honest place to put a
 * line when the two boxes are different shapes.
 */
export function canSplitEntity(change: EntityChange): boolean {
  if (change.kind !== 'modified') return false

  return !change.changes.some(
    ({ property }) => property === 'size.width' || property === 'size.height'
  )
}
